import React from 'react';
import { useTEF } from 'src/tef/components/providers/TEFProvider';
import { cn } from 'src/tef/components/utils/cn';
import { forwardProps } from 'src/tef/components/utils/forwardProps';
import type { ForwardedHTMLProps } from 'src/tef/components/utils/types';

interface FormErrorProps extends ForwardedHTMLProps {
  children: React.ReactNode;
  className?: string;
}

export const FormError = React.forwardRef<HTMLParagraphElement, FormErrorProps>(
  ({ children, className, ...props }, ref) => {
    const tef = useTEF();
    const forwardedProps = forwardProps(props);

    if (!children) return null;

    return (
      <p
        ref={ref}
        className={cn('mt-1', tef.typography.textSm, tef.colors.error, className)}
        role="alert"
        {...forwardedProps}
        {...props}
      >
        {children}
      </p>
    );
  }
);

FormError.displayName = 'FormError';
